import { baseApi } from "api/BaseApi";

const VIRTUAL_TEAM_BASE_URL = "virtual-team";

const virtualTeamApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    isValidatorResponseTeamMember: build.query<boolean, void>({
      query: () => ({
        url: `${VIRTUAL_TEAM_BASE_URL}/members/is_validator_response_team_member/`,
      }),
      transformResponse: (response: { is_member: boolean }) =>
        response.is_member,
    }),
    isErtTeamMember: build.query<boolean, void>({
      query: () => ({
        url: `${VIRTUAL_TEAM_BASE_URL}/members/is_ert_team_member/`,
      }),
      transformResponse: (response: { is_member: boolean }) =>
        response.is_member,
    }),
  }),

  overrideExisting: false,
});

export const {
  useIsValidatorResponseTeamMemberQuery,
  useIsErtTeamMemberQuery,
} = virtualTeamApi;
